import { PaginationBottom } from "@gromia/components/ui/PaginationBottom";
import { BlogListPage } from "@gromia/utils/models/blog";
import * as React from "react";

type Props = {
  page: BlogListPage;
  pagination: (n: number) => string;
};

export function Pagination(props: Props) {
  const p = props.page;
  return (
    <PaginationBottom
      pagination={props.pagination}
      data={{
        count: p.count,
        size: p.size,
        page: p.currentPage,
        perPage: p.perPage,
        pages: p.totalPages,
      }}
    />
  );
}
